import { useQuery } from "urql";
import {
  SongbookListQueryQuery,
  SongbookListQueryQueryVariables,
} from "../gql/graphql";
import { TypedDocumentNode } from "@graphql-typed-document-node/core";
import { graphql } from "../gql";

export function useSongbooksQuery() {
  const [result, reexecuteQuery] = useQuery({
    query: songbookListQuery,
  });

  const { data } = result;

  return {
    songbooks: data?.songbooks,
    reexecuteQuery,
  };
}

export const songbookListQuery: TypedDocumentNode<
  SongbookListQueryQuery,
  SongbookListQueryQueryVariables
> = graphql(`
  query songbookListQuery {
    songbooks {
      id
      bucket
      mnemonic
      name
    }
  }
`);
